import { Link } from 'react-router-dom'

import { MARKETING_BOOK_DEMO_URL } from '../config/commandDeckMvp'
import type { UserAccessSnapshot } from '../contracts/types'

interface Props {
  access: UserAccessSnapshot
}

export function CommandDeckAccessHoldPanel({ access }: Props) {
  const pathway =
    access.accessState === 'requested_access' || access.accessState === 'demo_booked'

  return (
    <section
      className="command-deck-section command-deck-glass command-deck-status--blocked"
      aria-labelledby="cd-hold-heading"
    >
      <h2 id="cd-hold-heading">Access hold — interiors locked</h2>
      <p style={{ margin: '0 0 12px', color: 'var(--cd-muted)', lineHeight: 1.5 }}>
        {pathway
          ? 'Your pathway is recorded. Command Deck shows your live access state; product interiors stay fail-closed until a grant is issued.'
          : 'Your account does not have an active interior grant. This dashboard reflects live session truth — not preview fixtures.'}
      </p>
      <div className="command-deck-actions">
        <Link className="command-deck-btn command-deck-btn--primary" to="/access">
          Review access status
        </Link>
        <a className="command-deck-btn" href={MARKETING_BOOK_DEMO_URL} target="_blank" rel="noreferrer">
          Book demo
        </a>
      </div>
    </section>
  )
}
